import { Container } from '@material-ui/core';
import React from 'react';

export default function BaseContainer({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>;
}
